<template>
  <div>
    <div
      class="calendar-container-background"
      :class="{ 'is-active': isActive }"
      @click="$emit('close')"
    ></div>
    <div class="calendar-container" :class="{ 'is-active': isActive }">
      <div class="has-text-right">
        <a class="delete" @click="$emit('close')"></a>
      </div>

      <div class="buttons has-addons is-centered">
        <button class="button" @click="handleSubYear()">
          <span class="icon is-small">
            <i class="fas fa-angle-double-left"></i>
          </span>
        </button>

        <button class="button" v-if="list === 'day'" @click="handleSubMonth()">
          <span class="icon is-small">
            <i class="fas fa-angle-left"></i>
          </span>
        </button>

        <button
          v-if="list === 'day'"
          class="button"
          @click="openMonthSelector()"
        >
          {{ monthLabel }}
        </button>

        <button
          v-if="list === 'day' || list === 'month'"
          class="button"
          @click="openYearSelector()"
        >
          {{ calendarYear }}
        </button>

        <button v-if="list === 'year'" class="button" readonly>
          {{ decade }} ~ {{ decade + 9 }}
        </button>

        <button class="button" v-if="list === 'day'" @click="handleAddMonth()">
          <span class="icon is-small">
            <i class="fas fa-angle-right"></i>
          </span>
        </button>

        <button class="button" @click="handleAddYear()">
          <span class="icon is-small">
            <i class="fas fa-angle-double-right"></i>
          </span>
        </button>
      </div>
      <ListYear
        v-show="list === 'year'"
        :decade="decade"
        @change="yearChange"
      />
      <ListMonth v-show="list === 'month'" @change="monthChange" />
      <ListDay
        v-show="list === 'day'"
        :calendarYear="calendarYear"
        :calendarMonth="calendarMonth"
        :calendarDate="formatedDate"
        :minDate="minDate"
        :maxDate="maxDate"
        @change="dayChange"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";

import ListYear from "../date/ListYear";
import ListMonth from "../date/ListMonth";
import ListDay from "../date/ListDay";

import { isValidDate } from "../utils/date";
import locale from "../locale/locale";

export default {
  name: "calendar-panel",
  components: {
    ListYear,
    ListMonth,
    ListDay,
  },
  props: {
    value: {
      type: String,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    minDate: {
      type: String,
      default: null,
    },
    maxDate: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      list: "day",
      date: null,
      innerCalendar: null,
    };
  },
  computed: {
    formatedDate() {
      return moment(this.date).format("DD/MM/YYYY");
    },
    decade() {
      return Math.floor(this.calendarYear / 10) * 10;
    },
    calendarYear() {
      return this.innerCalendar !== null
        ? this.innerCalendar.getFullYear()
        : new Date().getFullYear();
    },
    calendarMonth() {
      return this.innerCalendar !== null
        ? this.innerCalendar.getMonth()
        : new Date().getMonth();
    },
    monthLabel() {
      return locale.info.monthsShort[this.calendarMonth];
    },
    calendarDate() {
      return this.innerCalendar.getDate();
    },
  },
  watch: {
    value() {
      this.initCalendar();
    },
  },
  methods: {
    initCalendar() {
      this.list = "day";
      let calendarDate = moment(this.value, "DD/MM/YYYY").toDate();
      if (!isValidDate(calendarDate)) {
        calendarDate = new Date();
      }
      this.date = calendarDate;
      this.innerCalendar = calendarDate;
    },
    updateCalendar(date) {
      this.innerCalendar = date;
    },
    showListYear() {
      this.list = "year";
    },
    showListMonth() {
      this.list = "month";
    },
    showListDay() {
      this.list = "day";
    },
    handleAddMonth() {
      const newCalendar = moment(this.innerCalendar).add(1, "months").toDate();
      this.updateCalendar(newCalendar);
    },
    handleSubMonth() {
      const newCalendar = moment(this.innerCalendar)
        .subtract(1, "months")
        .toDate();
      this.updateCalendar(newCalendar);
    },
    handleAddYear() {
      let newCalendar;
      if (this.list === "year") {
        newCalendar = moment(this.innerCalendar).add(10, "years").toDate();
      } else {
        newCalendar = moment(this.innerCalendar).add(1, "years").toDate();
      }
      this.updateCalendar(newCalendar);
    },
    handleSubYear() {
      let newCalendar;
      if (this.list === "year") {
        newCalendar = moment(this.innerCalendar).subtract(10, "years").toDate();
      } else {
        newCalendar = moment(this.innerCalendar).subtract(1, "years").toDate();
      }
      this.updateCalendar(newCalendar);
    },
    openMonthSelector() {
      this.list = "month";
    },
    openYearSelector() {
      this.list = "year";
    },
    openDaySelector() {
      this.list = "day";
    },
    yearChange(year) {
      this.openMonthSelector();
      let newCalendar = moment(this.innerCalendar).set("year", year).toDate();
      this.updateCalendar(newCalendar);
    },
    monthChange(month) {
      this.openDaySelector();
      let newCalendar = moment(this.innerCalendar)
        .set("month", month - 1)
        .toDate();
      this.updateCalendar(newCalendar);
    },
    dayChange(day) {
      let date = moment(new Date(this.calendarYear, this.calendarMonth, day));
      this.date = date;
      let formated = this.formatedDate;
      this.$emit("input", formated);
    },
  },
};
</script>

<style lang="scss">
@mixin noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}

.calendar-container-background {
  background-color: rgba(10, 10, 10, 0.86);
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: none;

  &.is-active {
    display: inline-block;
  }
}

.calendar-container {
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  padding: 0.25rem;
  min-width: 312px;
  z-index: 110;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  background-color: #fff;
  display: none;

  &.is-active {
    display: inline-block;
  }

  & .table td,
  & .table th {
    text-align: center;
  }
  @include noselect;

  & .button .icon:first-child:last-child {
    margin: 0;
  }
}

</style>